
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import MainLandingPage from './components/MainLandingPage.tsx';
import AstralMapPage from './components/AstralMapPage.tsx';
import Login from './components/admin/Login.tsx';
import AdminDashboard from './components/admin/AdminDashboard.tsx';
import ProtectedRoute from './components/admin/ProtectedRoute.tsx';
import './localization/i18n';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App p-2 md:p-6 overflow-x-hidden">
          <Routes>
            <Route path="/" element={<MainLandingPage />} />
            <Route path="/astral-map" element={<AstralMapPage />} />
            <Route path="/admin/login" element={<Login />} />
            <Route 
              path="/admin" 
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              } 
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App; 